// tslint:disable
/**
 * Property Management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ProblemDetails } from '../models';
import { StartGuestReportRequest } from '../models';
import { StartGuestReportResponse } from '../models';
import { SubmitGuestMaintenanceTicketResponse } from '../models';
/**
 * GuestReportApi - axios parameter creator
 * @export
 */
export const GuestReportApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {StartGuestReportRequest} [startGuestReportRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGuestreportStartPost(
      propertyId: string,
      startGuestReportRequest?: StartGuestReportRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling propertyIdGuestreportStartPost.'
        );
      }
      const localVarPath = `/{propertyId}/guestreport/start`.replace(
        `{${'propertyId'}}`,
        encodeURIComponent(String(propertyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof startGuestReportRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(startGuestReportRequest !== undefined ? startGuestReportRequest : {})
        : startGuestReportRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} userId
     * @param {string} reservationId
     * @param {string} [notes]
     * @param {any} [photo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGuestreportSubmitPost(
      propertyId: string,
      userId: string,
      reservationId: string,
      notes?: string,
      photo?: any,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling propertyIdGuestreportSubmitPost.'
        );
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling propertyIdGuestreportSubmitPost.'
        );
      }
      // verify required parameter 'reservationId' is not null or undefined
      if (reservationId === null || reservationId === undefined) {
        throw new RequiredError(
          'reservationId',
          'Required parameter reservationId was null or undefined when calling propertyIdGuestreportSubmitPost.'
        );
      }
      const localVarPath = `/{propertyId}/guestreport/submit`.replace(
        `{${'propertyId'}}`,
        encodeURIComponent(String(propertyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (userId !== undefined) {
        localVarFormParams.append('UserId', userId as any);
      }

      if (reservationId !== undefined) {
        localVarFormParams.append('ReservationId', reservationId as any);
      }

      if (notes !== undefined) {
        localVarFormParams.append('Notes', notes as any);
      }

      if (photo !== undefined) {
        localVarFormParams.append('Photo', photo as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GuestReportApi - functional programming interface
 * @export
 */
export const GuestReportApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {StartGuestReportRequest} [startGuestReportRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGuestreportStartPost(
      propertyId: string,
      startGuestReportRequest?: StartGuestReportRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartGuestReportResponse> {
      const localVarAxiosArgs = GuestReportApiAxiosParamCreator(
        configuration
      ).propertyIdGuestreportStartPost(propertyId, startGuestReportRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} userId
     * @param {string} reservationId
     * @param {string} [notes]
     * @param {any} [photo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGuestreportSubmitPost(
      propertyId: string,
      userId: string,
      reservationId: string,
      notes?: string,
      photo?: any,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<SubmitGuestMaintenanceTicketResponse> {
      const localVarAxiosArgs = GuestReportApiAxiosParamCreator(
        configuration
      ).propertyIdGuestreportSubmitPost(propertyId, userId, reservationId, notes, photo, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * GuestReportApi - factory interface
 * @export
 */
export const GuestReportApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {StartGuestReportRequest} [startGuestReportRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGuestreportStartPost(
      propertyId: string,
      startGuestReportRequest?: StartGuestReportRequest,
      options?: any
    ): AxiosPromise<StartGuestReportResponse> {
      return GuestReportApiFp(configuration).propertyIdGuestreportStartPost(
        propertyId,
        startGuestReportRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} userId
     * @param {string} reservationId
     * @param {string} [notes]
     * @param {any} [photo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGuestreportSubmitPost(
      propertyId: string,
      userId: string,
      reservationId: string,
      notes?: string,
      photo?: any,
      options?: any
    ): AxiosPromise<SubmitGuestMaintenanceTicketResponse> {
      return GuestReportApiFp(configuration).propertyIdGuestreportSubmitPost(
        propertyId,
        userId,
        reservationId,
        notes,
        photo,
        options
      )(axios, basePath);
    },
  };
};

/**
 * GuestReportApi - object-oriented interface
 * @export
 * @class GuestReportApi
 * @extends {BaseAPI}
 */
export class GuestReportApi extends BaseAPI {
  /**
   *
   * @param {string} propertyId
   * @param {StartGuestReportRequest} [startGuestReportRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GuestReportApi
   */
  public propertyIdGuestreportStartPost(
    propertyId: string,
    startGuestReportRequest?: StartGuestReportRequest,
    options?: any
  ) {
    return GuestReportApiFp(this.configuration).propertyIdGuestreportStartPost(
      propertyId,
      startGuestReportRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} propertyId
   * @param {string} userId
   * @param {string} reservationId
   * @param {string} [notes]
   * @param {any} [photo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GuestReportApi
   */
  public propertyIdGuestreportSubmitPost(
    propertyId: string,
    userId: string,
    reservationId: string,
    notes?: string,
    photo?: any,
    options?: any
  ) {
    return GuestReportApiFp(this.configuration).propertyIdGuestreportSubmitPost(
      propertyId,
      userId,
      reservationId,
      notes,
      photo,
      options
    )(this.axios, this.basePath);
  }
}
